module.exports = new __parcel__URL__("machines_tab_active.e51b08b1.png").toString();